module.exports = __webpack_public_path__ + "static/media/warehouse_16_white.89087408.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/warehouse_16_white.svg
// module id = 1406
// module chunks = 0